import { render, staticRenderFns } from "./BrandAttribute.vue?vue&type=template&id=5085c0a2"
import script from "./BrandAttribute.vue?vue&type=script&lang=js"
export * from "./BrandAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports